import { render, staticRenderFns } from "./account_extract_detail.vue?vue&type=template&id=2fa4a4a9&scoped=true"
import script from "./account_extract_detail.vue?vue&type=script&lang=js"
export * from "./account_extract_detail.vue?vue&type=script&lang=js"
import style0 from "./account_extract_detail.vue?vue&type=style&index=0&id=2fa4a4a9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4a4a9",
  null
  
)

export default component.exports